import React from "react";
import classNames from "classnames";
import { CardFooterProps } from "../../../types/components/Card";

const CardFooter: React.FC<CardFooterProps> = ({
  align = 'start',
  padding,
  stacked,
  stretch,
  divided,
  className,
  children,
}) => (
  <div
    className={classNames(
      'bwp-card__footer',
      `bwp-card__footer--${align}`,
      {
        'bwp-card__footer--stacked': stacked,
        'bwp-card__footer--stretch': stretch,
        'bwp-card__footer--divided': divided,
        [`bwp-card__footer--${padding}`]: padding && padding !== 'default',
      },
      className,
    )}
  >
    {children}
  </div>
);

export default CardFooter;